<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :search="search"
    :disable-initial-sort="true"
    :total-items="total"
    :pagination.sync="pagination"
    rows-per-page-text="Por página"
    :rows-per-page-items='[10, 25, 50, {"text": "Todo", "value": -1}]'
    :loading="loading==true"
    :hide-actions="hideActions">
    <template slot="pageText" slot-scope="props">
      {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
    </template>
    <template slot="items" slot-scope="props">
      <tr @click="rowAction(props.item.id)">
        <slot name="row" :item="props.item" />
      </tr>
    </template>
    <template slot="no-data">
      <v-layout class="title my-5 accent--text justify-center" icon="warning">
        <p>No hay datos para mostrar</p>
      </v-layout>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'dataTable',
  props: ['items', 'headers', 'loading', 'rowAction', 'search', 'total', 'page', 'hideActions'],
  created () {
    this.getUrlParams()
  },
  data () {
    return {
      pagination: {
        page: 1,
        sortBy: false,
        descending: false
      },
      paginationParams: {
        'page': 'page',
        'page_size': 'rowsPerPage',
        'o': this.parseSortedBy
      },
      loadedByUrl: false
    }
  },
  methods: {
    getUrlParams () {
      Object.keys(this.paginationParams).forEach(key => {
        if (!this.$route['query'][key]) { return }
        if (typeof this.paginationParams[key] === 'function') {
          this.paginationParams[key](this.$route['query'][key])
        } else if (!isNaN(parseInt(this.$route['query'][key]))) {
          this.pagination[this.paginationParams[key]] = parseInt(this.$route['query'][key])
        } else {
          this.pagination[this.paginationParams[key]] = this.$route['query'][key]
        }
      })
      this.loadedByUrl = true
    },
    parseSortedBy (orderBy) {
      if (orderBy.charAt(0) === '-') {
        this.pagination.descending = true
        this.pagination.sortBy = orderBy.substring(1)
      } else {
        this.pagination.descending = false
        this.pagination.sortBy = orderBy
      }
    },
    getParsedOrderBy () {
      if (this.pagination.descending) {
        return '-' + this.pagination.sortBy
      } else {
        return this.pagination.sortBy
      }
    }
  },
  watch: {
    pagination: {
      handler () {
        this.$emit('paginationUpdated', {
          page: this.pagination.page,
          page_size: this.pagination.rowsPerPage,
          o: this.getParsedOrderBy()
        })
      },
      deep: true
    },
    page: {
      handler () {
        this.pagination.page = this.page
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/DataTable.vue